const { queryFeedbackWidgets } = require('@hotjar/feedback/domain/IncomingFeedback/query');

// This service is a work-around that lets us mock out the query functions in the angular tests
angular.module('hjSurveysModule').service('FeedbackQuery', function () {
    this.queryFeedbackWidgets = function (site) {
        return queryFeedbackWidgets(site);
    };
});
